module.exports = __webpack_public_path__ + "static/feed@2x-faad967eb04b5213edc5adf7cffd9bec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/feed@2x.jpg
// module id = 2579
// module chunks = 168707334958949